import { useState } from "react";
import "./CareerForm.css";
import { careerPositions } from "../../dynamicdatas/careerFormData";

export default function CareerSection() {
  const [selectedJob, setSelectedJob] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    // TEMP: just log to check UI
    console.log("Form Data:", Object.fromEntries(formData));
    alert("Form ready for backend submission");
  };

  return (
    <section className="career-container">
      {/* LEFT SIDE */}
      <div className="career-left">
        <img
          src="https://images.unsplash.com/photo-1600891964599-f61ba0e24092"
          alt="Restaurant"
          className="career-image"
        />

        <div className="career-info">
          <h4 className="career-small-title">JOIN OUR TEAM</h4>
          <p className="career-address">
            100 Kings Road, Sydney,
            <br />
            NS, B1S 1A1
          </p>
          <p className="career-contact">
            Call: +85-123-456789 | Email: hr@yourcompany.com
          </p>
        </div>
      </div>

      {/* RIGHT SIDE FORM */}
      <div className="career-right">
        <h3 className="career-right-title">Apply for Job</h3>
        <p className="career-desc">
          Fill your details – our HR team will contact you!
        </p>

        <form className="career-form" onSubmit={handleSubmit} encType="multipart/form-data">
          <input type="text" name="name" placeholder="Your Name" required />
          <input type="email" name="email" placeholder="Email Address" required />
          <input type="text" name="phone" placeholder="Phone Number" required />

          <select
            name="position"
            value={selectedJob}
            onChange={(e) => setSelectedJob(e.target.value)}
            required
          >
            <option value="">Select Position</option>
            {careerPositions.map((job) => (
              <option key={job.id} value={job.title}>
                {job.title}
              </option>
            ))}
          </select>

          {/* PHOTO UPLOAD */}
          <div className="file-field">
            <label>Upload Photo</label>
            <input type="file" name="photo" accept="image/*" required />
          </div>

          {/* CV UPLOAD */}
          <div className="file-field">
            <label>Upload CV</label>
            <input type="file" name="cv" accept=".pdf,.doc,.docx" required />
          </div>

          <textarea
            name="message"
            rows="5"
            placeholder="Why should we hire you?"
            required
          />

          <button type="submit" className="career-submit-btn">
            SEND APPLICATION
          </button>
        </form>
      </div>
    </section>
  );
}
